module.exports = __webpack_public_path__ + "img/Content.fb85e23a.png";